export default __webpack_public_path__ + "static/media/nodes.46098e19.png";